import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormDynamicTextField, FormDynamicTextFieldInput, FormFields } from "sprint-common-web";

import { useEditShreqIdsForm } from "./useEditShreqIdsForm";

export interface EditShreqIdsFormProps {
    systemId: string;
    onCancel(): void;
    onSubmit(): void;
}

export interface EditShreqIdsFormInputs {
    shreqIds: FormDynamicTextFieldInput[];
}

export const EditShreqIdsForm = ({ systemId, onSubmit, onCancel }: EditShreqIdsFormProps): JSX.Element => {
    const { itemToEdit, editShreqIds } = useEditShreqIdsForm(systemId);

    const { errors, control, formState, handleSubmit } = useForm<EditShreqIdsFormInputs>({
        defaultValues: {
            shreqIds: itemToEdit.map((shreqId) => ({ value: shreqId }))
        },
        criteriaMode: "all"
    });

    const handleEditShreqIds = async (inputs: EditShreqIdsFormInputs) => {
        await editShreqIds(inputs);
        onSubmit();
    };

    return (
        <Form onSubmit={handleSubmit(handleEditShreqIds)}>
            <FormFields>
                <FormDynamicTextField control={control} errors={errors} label="Shreq Id" name="shreqIds" />
            </FormFields>
            <FormActions isLoading={formState.isValidating || formState.isSubmitting} onCancel={onCancel} />
        </Form>
    );
};
